import type { ProjectsType } from "@/entities/projects/model/types";
import Typography from "@/shared/ui/Typography";
import { ProjectSlider } from "@/widgets/sliders/project_slider/ui";

export interface IProjectSliderSectionProps {
    projects: ProjectsType | undefined;
}

export function ProjectSliderSection({ projects }: IProjectSliderSectionProps) {

    if(!projects)
        return null;

    return (
        <section className="w-full flex flex-col py-[40px] gap-[20px] md:gap-[26px]">
            <div className="container">
                <Typography tag="h2">
                    похожие предложения
                </Typography>    
            </div>
            
            <ProjectSlider
                projects ={projects}
            />

        </section>
    )
}
